import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { taskShape } from "utils/propTypeShapes"
import { CheckmarkCircleIcon } from "shared/icons"
import TruncatedWithTooltip from "shared/TruncatedWithTooltip"
import TaskHeaderAssigneesOverview from "./TaskHeaderAssigneesOverview"
import TaskDueDate from "./TaskDueDate"
import TaskTokenTitle from "./TaskTokenTitle"

const TaskItemRowHeaderContent = ({ showAssignees = true, task, toggleTaskVisibility }) => {
  const {
    assigneeIds: taskAssigneeIds,
    dueDate: taskDueDate,
    isDeleted: taskIsDeleted,
    isOpen: taskIsOpen,
    isOverdue: taskIsOverdue,
    subform: taskSubform,
    title: taskTitle,
    userTaskPermissions,
  } = task

  const { canSeeDetails: userCanSeeDetails } = userTaskPermissions
  const userPermittedToSeeDetails = userCanSeeDetails && !taskIsDeleted

  const itemRowHeaderContentBreakerClass = userPermittedToSeeDetails
    ? "item-row-header-content-breaker-double"
    : "item-row-header-content-breaker"

  return (
    <div className="w-full min-w-0 flex flex-col lg:flex-row gap-4 lg:items-center justify-between">
      <div className="min-w-0 flex flex-col lg:flex-row gap-4 lg:items-center">
        <div className="flex items-center gap-2 shrink-0 mb-2 lg:mb-0">
          {
            taskIsOpen
              ? <div className="w-5 h-5 shrink-0 border rounded-full" />
              : <CheckmarkCircleIcon className="w-5 h-5 shrink-0" />
          }
          <TaskDueDate dueDate={taskDueDate} isOverdue={taskIsOverdue} />
        </div>
        {
          userPermittedToSeeDetails
            ? (
              <button
                className={clsx(itemRowHeaderContentBreakerClass, "min-w-0 font-medium text-left")}
                onClick={toggleTaskVisibility}
              >
                <TruncatedWithTooltip className="block" text={taskTitle} truncateAt="lg" />
              </button>
            )
            : (
              <span className={clsx(itemRowHeaderContentBreakerClass, "min-w-0 font-medium")}>
                <TruncatedWithTooltip className="block" text={taskTitle} truncateAt="lg" />
              </span>
            )
        }
      </div>
      <div className={clsx(itemRowHeaderContentBreakerClass, "min-w-0 flex items-center gap-4 lg:contents")}>
        <TaskTokenTitle className="lg:max-w-[12rem] lg:ml-auto lg:shrink-0" formTitleTruncateAt="lg" subform={taskSubform} />
        {
          showAssignees && (
            <TaskHeaderAssigneesOverview assigneeIds={taskAssigneeIds} />
          )
        }
      </div>
    </div>
  )
}

TaskItemRowHeaderContent.propTypes = {
  showAssignees: types.bool,
  task: taskShape.isRequired,
  toggleTaskVisibility: types.func.isRequired,
}

export default TaskItemRowHeaderContent
